/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseCircleFilled = createIcon({
  name: 'icon-close-circle-filled',
  content: '<path d="M667.904 704.32L508.992 546.56l-157.888 158.912-45.376-45.056 157.824-158.976L304.64 343.488l45.12-45.376 158.912 157.824 157.888-158.848 45.44 45.056L553.984 501.12l158.976 157.888-45.12 45.44zM510.528 64a448 448 0 1 0 2.944 896 448 448 0 0 0-2.944-896z" fill="currentColor"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCloseCircleFilled;
